var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-border-container"},[_c('div',{staticClass:"top"}),_c('div',{staticClass:"middle"}),_c('div',{staticClass:"bottom"})])}]

export { render, staticRenderFns }